import { Tab } from '@mui/material';
import { Link, useLocation } from '@tanstack/react-router';
import { useContext, useEffect } from 'react';
import { PageContext } from 'src/contexts/page-context';

interface Props {
  href: string;
  tabIndex: number;
  label: string;
}

const PageTab = ({ href, label, tabIndex }: Props) => {
  const location = useLocation();
  const { setTabIndex } = useContext(PageContext);

  useEffect(() => {
    const isActiveHref = location.pathname === href;

    if (isActiveHref) {
      setTabIndex(tabIndex);
    }
  }, [location.pathname, href]);

  return <Tab component={Link} label={label} to={href} />;
};

export default PageTab;
